import * as Types from '../graphql.generated';

import { Seo_FragmentFragment } from './seo.fragment.generated';
import { Ad_Targeting_FragmentFragment } from './adTargeting.fragment.generated';
import { Analytics_Eccomerce_FragmentFragment } from './analyticsEcommerce.fragment.generated';
import { Analytics_Taxonomy_FragmentFragment } from './analyticTaxonomy.fragment.generated';
import { Links_FragmentFragment } from './links.fragment.generated';
import { Listing_Ss_FragmentFragment } from './listingSS.fragment.generated';
import { Meta_Info_FragmentFragment } from './metaInfo.fragment.generated';
import { Pagination_FragmentFragment } from './pagination.fragment.generated';
import { Saved_Search_And_Alerts_FragmentFragment } from './savedSearchAndAlerts.fragment.generated';
import { Seo_Blurb_FragmentFragment } from './seoBlurb.fragment.generated';
import { Seo_Accordions_FragmentFragment } from './seoAccordions.fragment.generated';
import { Listing_FragmentFragment } from './listing.fragment.generated';
import { Seo_FragmentFragmentDoc } from './seo.fragment.generated';
import { Ad_Targeting_FragmentFragmentDoc } from './adTargeting.fragment.generated';
import { Analytics_Eccomerce_FragmentFragmentDoc } from './analyticsEcommerce.fragment.generated';
import { Analytics_Taxonomy_FragmentFragmentDoc } from './analyticTaxonomy.fragment.generated';
import { Links_FragmentFragmentDoc } from './links.fragment.generated';
import { Listing_Ss_FragmentFragmentDoc } from './listingSS.fragment.generated';
import { Meta_Info_FragmentFragmentDoc } from './metaInfo.fragment.generated';
import { Pagination_FragmentFragmentDoc } from './pagination.fragment.generated';
import { Saved_Search_And_Alerts_FragmentFragmentDoc } from './savedSearchAndAlerts.fragment.generated';
import { Seo_Blurb_FragmentFragmentDoc } from './seoBlurb.fragment.generated';
import { Seo_Accordions_FragmentFragmentDoc } from './seoAccordions.fragment.generated';
import { Listing_FragmentFragmentDoc } from './listing.fragment.generated';
export type LogSearchMutationVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type LogSearchMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'logSearch'
>;

export type ApiSearchByUrlQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type ApiSearchByUrlQuery = { __typename?: 'Query' } & {
    seo?: Types.Maybe<
        | ({ __typename?: 'SeoResults' } & Seo_FragmentFragment)
        | ({ __typename?: 'SeoResultsError' } & Pick<
              Types.SeoResultsError,
              'errorCode'
          >)
    >;
    searchResults?: Types.Maybe<
        { __typename?: 'Results' } & Pick<
            Types.Results,
            'title' | 'userAlertId'
        > & {
                adTargeting?: Types.Maybe<
                    {
                        __typename?: 'AdTargeting';
                    } & Ad_Targeting_FragmentFragment
                >;
                analyticsEcommerce?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsEcommerce';
                    } & Analytics_Eccomerce_FragmentFragment
                >;
                analyticsTaxonomy?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsTaxonomy';
                    } & Analytics_Taxonomy_FragmentFragment
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Links_FragmentFragment
                >;
                listings?: Types.Maybe<
                    { __typename?: 'Listings' } & {
                        regular?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Ss_FragmentFragment
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Ss_FragmentFragment
                                >
                            >
                        >;
                        featured?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Ss_FragmentFragment
                                >
                            >
                        >;
                    }
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Meta_Info_FragmentFragment
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pagination_FragmentFragment
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    {
                        __typename?: 'SavedSearchAndAlerts';
                    } & Saved_Search_And_Alerts_FragmentFragment
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Seo_Blurb_FragmentFragment
                >;
            }
    >;
};

export type GetListingDataQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingDataQuery = { __typename?: 'Query' } & {
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & Pick<
                Types.Breadcrumbs,
                'label' | 'tracking' | 'uri' | 'noAppend' | 'i18nLabelKey'
            >
        >
    >;
    redirects?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'Redirect' } & Pick<
                    Types.Redirect,
                    'code' | 'redirectUri'
                >
            >
        >
    >;
    seoAccordions?: Types.Maybe<
        Array<
            Types.Maybe<
                {
                    __typename?: 'SeoAccordions';
                } & Seo_Accordions_FragmentFragment
            >
        >
    >;
    searchResults?: Types.Maybe<
        { __typename?: 'Results' } & Pick<
            Types.Results,
            'title' | 'userAlertId' | 'polyenc'
        > & {
                analyticsTaxonomy?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsTaxonomy';
                    } & Analytics_Taxonomy_FragmentFragment
                >;
                analyticsEcommerce?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsEcommerce';
                    } & Analytics_Eccomerce_FragmentFragment
                >;
                adTargeting?: Types.Maybe<
                    {
                        __typename?: 'AdTargeting';
                    } & Ad_Targeting_FragmentFragment
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Meta_Info_FragmentFragment
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pagination_FragmentFragment
                >;
                listings?: Types.Maybe<
                    { __typename?: 'Listings' } & {
                        regular?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                        featured?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                    }
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Links_FragmentFragment
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Seo_Blurb_FragmentFragment
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    {
                        __typename?: 'SavedSearchAndAlerts';
                    } & Saved_Search_And_Alerts_FragmentFragment
                >;
            }
    >;
};

export type UserFavouritesQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type UserFavouritesQuery = { __typename?: 'Query' } & {
    favourites?: Types.Maybe<
        { __typename?: 'Favourites' } & Pick<Types.Favourites, 'listings'>
    >;
};

export type FavouriteListingMutationVariables = Types.Exact<{
    id: Types.Scalars['ID'];
}>;

export type FavouriteListingMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'saveFavouriteListing'
>;

export type UnfavouriteListingMutationVariables = Types.Exact<{
    id: Types.Scalars['ID'];
}>;

export type UnfavouriteListingMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'deleteFavouriteListing'
>;

export type EmailAllMutationVariables = Types.Exact<{
    input: Types.EmailAllDetails;
}>;

export type EmailAllMutation = { __typename?: 'Mutation' } & {
    contactAgents?: Types.Maybe<
        { __typename?: 'EmailAllSubmission' } & {
            emailAll?: Types.Maybe<
                { __typename?: 'EmailAll' } & Pick<
                    Types.EmailAll,
                    'action' | 'showCaptcha'
                > & {
                        branches?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllBranchContact';
                                    } & Pick<
                                        Types.EmailAllBranchContact,
                                        | 'checked'
                                        | 'featured'
                                        | 'label'
                                        | 'logo'
                                        | 'name'
                                        | 'type'
                                        | 'telephone'
                                        | 'value'
                                    >
                                >
                            >
                        >;
                        branchesValidation?: Types.Maybe<
                            { __typename?: 'BranchesValidation' } & Pick<
                                Types.BranchesValidation,
                                'requiredError'
                            >
                        >;
                        formConfig?: Types.Maybe<
                            { __typename?: 'EmailAllFormConfig' } & {
                                fields?: Types.Maybe<
                                    Array<
                                        Types.Maybe<
                                            {
                                                __typename?: 'EmailAllFormConfigFields';
                                            } & {
                                                fieldset?: Types.Maybe<
                                                    {
                                                        __typename?: 'EmailAllFormConfigFieldset';
                                                    } & Pick<
                                                        Types.EmailAllFormConfigFieldset,
                                                        | 'hideLegend'
                                                        | 'i18NLegendKey'
                                                        | 'name'
                                                    > & {
                                                            fields?: Types.Maybe<
                                                                Array<
                                                                    Types.Maybe<
                                                                        {
                                                                            __typename?: 'EmailAllFormField';
                                                                        } & Pick<
                                                                            Types.EmailAllFormField,
                                                                            | 'name'
                                                                            | 'placeholder'
                                                                            | 'type'
                                                                            | 'value'
                                                                            | 'i18NLabelKey'
                                                                            | 'maxlength'
                                                                            | 'optional'
                                                                        > & {
                                                                                validationData?: Types.Maybe<
                                                                                    {
                                                                                        __typename?: 'EmailAllFormFieldValidation';
                                                                                    } & Pick<
                                                                                        Types.EmailAllFormFieldValidation,
                                                                                        | 'pattern'
                                                                                        | 'patternError'
                                                                                        | 'required'
                                                                                        | 'requiredError'
                                                                                    >
                                                                                >;
                                                                                options?: Types.Maybe<
                                                                                    Array<
                                                                                        Types.Maybe<
                                                                                            {
                                                                                                __typename?: 'EmailAllOption';
                                                                                            } & Pick<
                                                                                                Types.EmailAllOption,
                                                                                                | 'disabled'
                                                                                                | 'i18NLabelKey'
                                                                                                | 'label'
                                                                                                | 'selected'
                                                                                                | 'value'
                                                                                            >
                                                                                        >
                                                                                    >
                                                                                >;
                                                                            }
                                                                    >
                                                                >
                                                            >;
                                                        }
                                                >;
                                            }
                                        >
                                    >
                                >;
                            }
                        >;
                    }
            >;
            result?: Types.Maybe<
                { __typename?: 'EmailAllResult' } & Pick<
                    Types.EmailAllResult,
                    'leadIdentifier' | 'message'
                > & {
                        branches?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllResultBranches';
                                    } & Pick<
                                        Types.EmailAllResultBranches,
                                        | 'address'
                                        | 'branchDetailsUri'
                                        | 'branchDetailsUrl'
                                        | 'branchId'
                                        | 'companyId'
                                        | 'companyName'
                                        | 'logoUrl'
                                        | 'memberType'
                                        | 'name'
                                        | 'phone'
                                        | 'postcode'
                                    >
                                >
                            >
                        >;
                        trackingObjects?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllResultTracking';
                                    } & {
                                        ecommerce?: Types.Maybe<
                                            {
                                                __typename?: 'EmailAllResultEcommerce';
                                            } & {
                                                purchase?: Types.Maybe<
                                                    {
                                                        __typename?: 'EmailAllResultEcommercePurchase';
                                                    } & {
                                                        actionField?: Types.Maybe<
                                                            {
                                                                __typename?: 'EmailAllResultEcommercePurchaseAction';
                                                            } & Pick<
                                                                Types.EmailAllResultEcommercePurchaseAction,
                                                                | 'affiliation'
                                                                | 'id'
                                                                | 'revenue'
                                                            >
                                                        >;
                                                        products?: Types.Maybe<
                                                            Array<
                                                                Types.Maybe<
                                                                    {
                                                                        __typename?: 'EmailAllResultEcommerceProduct';
                                                                    } & Pick<
                                                                        Types.EmailAllResultEcommerceProduct,
                                                                        | 'brand'
                                                                        | 'category'
                                                                        | 'coupon'
                                                                        | 'id'
                                                                        | 'name'
                                                                        | 'position'
                                                                        | 'price'
                                                                        | 'quantity'
                                                                        | 'variant'
                                                                    >
                                                                >
                                                            >
                                                        >;
                                                    }
                                                >;
                                            }
                                        >;
                                    }
                                >
                            >
                        >;
                    }
            >;
        }
    >;
};

export type GetEmailAllQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetEmailAllQuery = { __typename?: 'Query' } & {
    emailAll?: Types.Maybe<
        { __typename?: 'EmailAll' } & Pick<
            Types.EmailAll,
            'action' | 'showCaptcha'
        > & {
                branches?: Types.Maybe<
                    Array<
                        Types.Maybe<
                            { __typename?: 'EmailAllBranchContact' } & Pick<
                                Types.EmailAllBranchContact,
                                | 'checked'
                                | 'featured'
                                | 'label'
                                | 'logo'
                                | 'name'
                                | 'type'
                                | 'telephone'
                                | 'value'
                            >
                        >
                    >
                >;
                formConfig?: Types.Maybe<
                    { __typename?: 'EmailAllFormConfig' } & {
                        fields?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllFormConfigFields';
                                    } & {
                                        fieldset?: Types.Maybe<
                                            {
                                                __typename?: 'EmailAllFormConfigFieldset';
                                            } & Pick<
                                                Types.EmailAllFormConfigFieldset,
                                                | 'hideLegend'
                                                | 'i18NLegendKey'
                                                | 'name'
                                            > & {
                                                    fields?: Types.Maybe<
                                                        Array<
                                                            Types.Maybe<
                                                                {
                                                                    __typename?: 'EmailAllFormField';
                                                                } & Pick<
                                                                    Types.EmailAllFormField,
                                                                    | 'name'
                                                                    | 'placeholder'
                                                                    | 'type'
                                                                    | 'value'
                                                                    | 'i18NLabelKey'
                                                                    | 'maxlength'
                                                                    | 'optional'
                                                                > & {
                                                                        validationData?: Types.Maybe<
                                                                            {
                                                                                __typename?: 'EmailAllFormFieldValidation';
                                                                            } & Pick<
                                                                                Types.EmailAllFormFieldValidation,
                                                                                | 'pattern'
                                                                                | 'required'
                                                                            >
                                                                        >;
                                                                        options?: Types.Maybe<
                                                                            Array<
                                                                                Types.Maybe<
                                                                                    {
                                                                                        __typename?: 'EmailAllOption';
                                                                                    } & Pick<
                                                                                        Types.EmailAllOption,
                                                                                        | 'disabled'
                                                                                        | 'i18NLabelKey'
                                                                                        | 'label'
                                                                                        | 'selected'
                                                                                        | 'value'
                                                                                    >
                                                                                >
                                                                            >
                                                                        >;
                                                                    }
                                                            >
                                                        >
                                                    >;
                                                }
                                        >;
                                    }
                                >
                            >
                        >;
                    }
                >;
            }
    >;
};

export type GetListingDataV2QueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingDataV2Query = { __typename?: 'Query' } & {
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & Pick<
                Types.Breadcrumbs,
                'label' | 'tracking' | 'uri' | 'noAppend' | 'i18nLabelKey'
            >
        >
    >;
    redirects?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'Redirect' } & Pick<
                    Types.Redirect,
                    'code' | 'redirectUri'
                >
            >
        >
    >;
    seoAccordions?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'SeoAccordions' } & Pick<
                    Types.SeoAccordions,
                    | 'category'
                    | 'expanded'
                    | 'geo'
                    | 'name'
                    | 'propertyType'
                    | 'section'
                    | 'transactionType'
                > & {
                        rows?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Row' } & {
                                        links?: Types.Maybe<
                                            Array<
                                                Types.Maybe<
                                                    {
                                                        __typename?: 'Link';
                                                    } & Pick<
                                                        Types.Link,
                                                        | 'category'
                                                        | 'geo'
                                                        | 'propertyType'
                                                        | 'section'
                                                        | 'transactionType'
                                                        | 'uri'
                                                    >
                                                >
                                            >
                                        >;
                                    }
                                >
                            >
                        >;
                        links?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Link' } & Pick<
                                        Types.Link,
                                        | 'category'
                                        | 'geo'
                                        | 'propertyType'
                                        | 'section'
                                        | 'transactionType'
                                        | 'uri'
                                    >
                                >
                            >
                        >;
                    }
            >
        >
    >;
    searchResultsV2?: Types.Maybe<
        { __typename?: 'ResultsV2' } & Pick<
            Types.ResultsV2,
            'title' | 'userAlertId' | 'polyenc'
        > & {
                analyticsTaxonomy?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsTaxonomy';
                    } & Analytics_Taxonomy_FragmentFragment
                >;
                analyticsEcommerce?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsEcommerce';
                    } & Analytics_Eccomerce_FragmentFragment
                >;
                adTargeting?: Types.Maybe<
                    {
                        __typename?: 'AdTargeting';
                    } & Ad_Targeting_FragmentFragment
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Meta_Info_FragmentFragment
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pagination_FragmentFragment
                >;
                results?: Types.Maybe<
                    { __typename?: 'ResultsList' } & {
                        main?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'ResultsItem' } & {
                                        data?: Types.Maybe<
                                            {
                                                __typename?: 'FeedListingItem';
                                            } & Pick<
                                                Types.FeedListingItem,
                                                'presentationType'
                                            > & {
                                                    listing?: Types.Maybe<
                                                        {
                                                            __typename?: 'Listing';
                                                        } & Listing_FragmentFragment
                                                    >;
                                                }
                                        >;
                                    }
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_FragmentFragment
                                >
                            >
                        >;
                    }
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Links_FragmentFragment
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Seo_Blurb_FragmentFragment
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    {
                        __typename?: 'SavedSearchAndAlerts';
                    } & Saved_Search_And_Alerts_FragmentFragment
                >;
            }
    >;
};

export const LogSearchDocument = `
    mutation logSearch($path: String!) {
  logSearch(url: $path)
}
    `;
export const ApiSearchByUrlDocument = `
    query apiSearchByUrl($path: String!) {
  seo(path: $path) {
    ... on SeoResults {
      ...SEO_FRAGMENT
    }
    ... on SeoResultsError {
      errorCode
    }
  }
  searchResults: searchByUrl(url: $path) {
    adTargeting {
      ...AD_TARGETING_FRAGMENT
    }
    analyticsEcommerce {
      ...ANALYTICS_ECCOMERCE_FRAGMENT
    }
    analyticsTaxonomy {
      ...ANALYTICS_TAXONOMY_FRAGMENT
    }
    links {
      ...LINKS_FRAGMENT
    }
    listings {
      regular {
        ...LISTING_SS_FRAGMENT
      }
      extended {
        ...LISTING_SS_FRAGMENT
      }
      featured {
        ...LISTING_SS_FRAGMENT
      }
    }
    metaInfo {
      ...META_INFO_FRAGMENT
    }
    pagination {
      ...PAGINATION_FRAGMENT
    }
    savedSearchAndAlerts {
      ...SAVED_SEARCH_AND_ALERTS_FRAGMENT
    }
    seoBlurb {
      ...SEO_BLURB_FRAGMENT
    }
    title
    userAlertId
  }
}
    ${Seo_FragmentFragmentDoc}
${Ad_Targeting_FragmentFragmentDoc}
${Analytics_Eccomerce_FragmentFragmentDoc}
${Analytics_Taxonomy_FragmentFragmentDoc}
${Links_FragmentFragmentDoc}
${Listing_Ss_FragmentFragmentDoc}
${Meta_Info_FragmentFragmentDoc}
${Pagination_FragmentFragmentDoc}
${Saved_Search_And_Alerts_FragmentFragmentDoc}
${Seo_Blurb_FragmentFragmentDoc}`;
export const GetListingDataDocument = `
    query getListingData($path: String!) {
  breadcrumbs(path: $path) {
    label
    tracking
    uri
    noAppend
    i18nLabelKey
  }
  redirects(path: $path) {
    code
    redirectUri
  }
  seoAccordions(path: $path) {
    ...SEO_ACCORDIONS_FRAGMENT
  }
  searchResults(path: $path) {
    analyticsTaxonomy {
      ...ANALYTICS_TAXONOMY_FRAGMENT
    }
    analyticsEcommerce {
      ...ANALYTICS_ECCOMERCE_FRAGMENT
    }
    adTargeting {
      ...AD_TARGETING_FRAGMENT
    }
    metaInfo {
      ...META_INFO_FRAGMENT
    }
    pagination {
      ...PAGINATION_FRAGMENT
    }
    listings {
      regular {
        ...LISTING_FRAGMENT
      }
      extended {
        ...LISTING_FRAGMENT
      }
      featured {
        ...LISTING_FRAGMENT
      }
    }
    links {
      ...LINKS_FRAGMENT
    }
    seoBlurb {
      ...SEO_BLURB_FRAGMENT
    }
    title
    userAlertId
    savedSearchAndAlerts {
      ...SAVED_SEARCH_AND_ALERTS_FRAGMENT
    }
    polyenc
  }
}
    ${Seo_Accordions_FragmentFragmentDoc}
${Analytics_Taxonomy_FragmentFragmentDoc}
${Analytics_Eccomerce_FragmentFragmentDoc}
${Ad_Targeting_FragmentFragmentDoc}
${Meta_Info_FragmentFragmentDoc}
${Pagination_FragmentFragmentDoc}
${Listing_FragmentFragmentDoc}
${Links_FragmentFragmentDoc}
${Seo_Blurb_FragmentFragmentDoc}
${Saved_Search_And_Alerts_FragmentFragmentDoc}`;
export const UserFavouritesDocument = `
    query userFavourites {
  favourites {
    listings
  }
}
    `;
export const FavouriteListingDocument = `
    mutation favouriteListing($id: ID!) {
  saveFavouriteListing(id: $id)
}
    `;
export const UnfavouriteListingDocument = `
    mutation unfavouriteListing($id: ID!) {
  deleteFavouriteListing(id: $id)
}
    `;
export const EmailAllDocument = `
    mutation emailAll($input: EmailAllDetails!) {
  contactAgents(input: $input) {
    emailAll {
      action
      branches {
        checked
        featured
        label
        logo
        name
        type
        telephone
        value
      }
      branchesValidation {
        requiredError
      }
      formConfig {
        fields {
          fieldset {
            fields {
              name
              placeholder
              type
              value
              i18NLabelKey
              maxlength
              optional
              validationData {
                pattern
                patternError
                required
                requiredError
              }
              options {
                disabled
                i18NLabelKey
                label
                selected
                value
              }
            }
            hideLegend
            i18NLegendKey
            name
          }
        }
      }
      showCaptcha
    }
    result {
      branches {
        address
        branchDetailsUri
        branchDetailsUrl
        branchId
        companyId
        companyName
        logoUrl
        memberType
        name
        phone
        postcode
      }
      leadIdentifier
      message
      trackingObjects {
        ecommerce {
          purchase {
            actionField {
              affiliation
              id
              revenue
            }
            products {
              brand
              category
              coupon
              id
              name
              position
              price
              quantity
              variant
            }
          }
        }
      }
    }
  }
}
    `;
export const GetEmailAllDocument = `
    query getEmailAll($path: String!) {
  emailAll(path: $path) {
    action
    branches {
      checked
      featured
      label
      logo
      name
      type
      telephone
      value
    }
    formConfig {
      fields {
        fieldset {
          fields {
            name
            placeholder
            type
            value
            i18NLabelKey
            maxlength
            optional
            validationData {
              pattern
              required
            }
            options {
              disabled
              i18NLabelKey
              label
              selected
              value
            }
          }
          hideLegend
          i18NLegendKey
          name
        }
      }
    }
    showCaptcha
  }
}
    `;
export const GetListingDataV2Document = `
    query getListingDataV2($path: String!) {
  breadcrumbs(path: $path) {
    label
    tracking
    uri
    noAppend
    i18nLabelKey
  }
  redirects(path: $path) {
    code
    redirectUri
  }
  seoAccordions(path: $path) {
    category
    expanded
    geo
    name
    propertyType
    section
    transactionType
    rows {
      links {
        category
        geo
        propertyType
        section
        transactionType
        uri
      }
    }
    links {
      category
      geo
      propertyType
      section
      transactionType
      uri
    }
  }
  searchResultsV2(input: {path: $path}) {
    analyticsTaxonomy {
      ...ANALYTICS_TAXONOMY_FRAGMENT
    }
    analyticsEcommerce {
      ...ANALYTICS_ECCOMERCE_FRAGMENT
    }
    adTargeting {
      ...AD_TARGETING_FRAGMENT
    }
    metaInfo {
      ...META_INFO_FRAGMENT
    }
    pagination {
      ...PAGINATION_FRAGMENT
    }
    results {
      main {
        data {
          ... on FeedListingItem {
            listing {
              ...LISTING_FRAGMENT
            }
            presentationType
          }
        }
      }
      extended {
        ...LISTING_FRAGMENT
      }
    }
    links {
      ...LINKS_FRAGMENT
    }
    seoBlurb {
      ...SEO_BLURB_FRAGMENT
    }
    title
    userAlertId
    savedSearchAndAlerts {
      ...SAVED_SEARCH_AND_ALERTS_FRAGMENT
    }
    polyenc
  }
}
    ${Analytics_Taxonomy_FragmentFragmentDoc}
${Analytics_Eccomerce_FragmentFragmentDoc}
${Ad_Targeting_FragmentFragmentDoc}
${Meta_Info_FragmentFragmentDoc}
${Pagination_FragmentFragmentDoc}
${Listing_FragmentFragmentDoc}
${Links_FragmentFragmentDoc}
${Seo_Blurb_FragmentFragmentDoc}
${Saved_Search_And_Alerts_FragmentFragmentDoc}`;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        logSearch(
            variables: LogSearchMutationVariables,
            options?: C
        ): Promise<LogSearchMutation> {
            return requester<LogSearchMutation, LogSearchMutationVariables>(
                LogSearchDocument,
                variables,
                options
            );
        },
        apiSearchByUrl(
            variables: ApiSearchByUrlQueryVariables,
            options?: C
        ): Promise<ApiSearchByUrlQuery> {
            return requester<ApiSearchByUrlQuery, ApiSearchByUrlQueryVariables>(
                ApiSearchByUrlDocument,
                variables,
                options
            );
        },
        getListingData(
            variables: GetListingDataQueryVariables,
            options?: C
        ): Promise<GetListingDataQuery> {
            return requester<GetListingDataQuery, GetListingDataQueryVariables>(
                GetListingDataDocument,
                variables,
                options
            );
        },
        userFavourites(
            variables?: UserFavouritesQueryVariables,
            options?: C
        ): Promise<UserFavouritesQuery> {
            return requester<UserFavouritesQuery, UserFavouritesQueryVariables>(
                UserFavouritesDocument,
                variables,
                options
            );
        },
        favouriteListing(
            variables: FavouriteListingMutationVariables,
            options?: C
        ): Promise<FavouriteListingMutation> {
            return requester<
                FavouriteListingMutation,
                FavouriteListingMutationVariables
            >(FavouriteListingDocument, variables, options);
        },
        unfavouriteListing(
            variables: UnfavouriteListingMutationVariables,
            options?: C
        ): Promise<UnfavouriteListingMutation> {
            return requester<
                UnfavouriteListingMutation,
                UnfavouriteListingMutationVariables
            >(UnfavouriteListingDocument, variables, options);
        },
        emailAll(
            variables: EmailAllMutationVariables,
            options?: C
        ): Promise<EmailAllMutation> {
            return requester<EmailAllMutation, EmailAllMutationVariables>(
                EmailAllDocument,
                variables,
                options
            );
        },
        getEmailAll(
            variables: GetEmailAllQueryVariables,
            options?: C
        ): Promise<GetEmailAllQuery> {
            return requester<GetEmailAllQuery, GetEmailAllQueryVariables>(
                GetEmailAllDocument,
                variables,
                options
            );
        },
        getListingDataV2(
            variables: GetListingDataV2QueryVariables,
            options?: C
        ): Promise<GetListingDataV2Query> {
            return requester<
                GetListingDataV2Query,
                GetListingDataV2QueryVariables
            >(GetListingDataV2Document, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
